const NewClientIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7368 18C14.7368 16.0854 12.3333 14.5333 9.36842 14.5333C6.40352 14.5333 4 16.0854 4 18M16.3158 15.4V12.8M16.3158 12.8V10.2M16.3158 12.8H13.6316M16.3158 12.8H19M9.36842 11.9333C7.39182 11.9333 5.78947 10.3813 5.78947 8.46667C5.78947 6.55208 7.39182 5 9.36842 5C11.345 5 12.9474 6.55208 12.9474 8.46667C12.9474 10.3813 11.345 11.9333 9.36842 11.9333Z"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewClientIcon;
